import DataObjectList from '../../../common/model/DataObjectList';

import TableauPage from './TableauPage';

export default class TableauPageList extends DataObjectList {
  getElementClassType() {
    return TableauPage;
  }
}